module.exports = __webpack_public_path__ + "img/logo-ae-w-alt.ad19929f.png";